import { vpp, VPP_API } from '../api/vpp';
import * as types from './types';

const setUnits = (payload) => ({ type: types.SET_UNITS, payload });
const setUnitStatus = (payload) => ({
  type: types.UNIT_STATUS_SUCCESS,
  payload,
});
const setUnit = (payload) => ({ type: types.SET_UNIT, payload });

export const getUnits =
  (params, cancelToken = null) =>
  (dispatch) => {
    let config = {
      params,
      cancelToken,
    };
    return vpp
      .get(VPP_API.unit, config)
      .then(({ data }) => {
        dispatch(setUnits(data));
      });
  };

export const getUnit = (id) => (dispatch) => vpp.get(VPP_API.unitId(id));

export const getAddendumPdf = (id) => (dispatch) =>
  vpp.get(VPP_API.downloadAddemdum(id));

export const updateUnit = (id, data) => (dispatch) =>
  vpp.patch(VPP_API.unitId(id), data);

export const updateUnitContact = (id, data) => (dispatch) =>
  vpp.patch(VPP_API.unitContact(id), data);

export const updateUnitNumber = (id, data) => (dispatch) =>
  vpp.patch(VPP_API.unitNumber(id), data);

export const updateUnitStatusSection = (id, data) => (dispatch) =>
  vpp.patch(VPP_API.unitStatusSection(id), data);

export const updateUnitTenantVehicles = (id, data) => (dispatch) =>
  vpp.patch(VPP_API.unitTenantVehicles(id), data);

export const updateUnitGuestVehicles = (id, data) => (dispatch) =>
  vpp.patch(VPP_API.unitGuestVehicles(id), data);

export const updateUnitTenantPermit = (id, vehicle) => (dispatch) =>
  vpp.patch(VPP_API.unitTenantVehiclePermit(id), vehicle);

export const updateUnitGuestPermit = (id, vehicle) => (dispatch) =>
  vpp.patch(VPP_API.unitGuestVehiclePermit(id), vehicle);

export const addUnitTenantVehicleSlot = (id) => (dispatch) =>
  vpp.post(VPP_API.unitTenantVehicleSlot(id));

export const addUnitGuestVehicleSlot = (id) => (dispatch) =>
  vpp.post(VPP_API.unitGuestVehicleSlot(id));

export const removeUnitTenantVehicleSlot = (id) => (dispatch) =>
  vpp.delete(VPP_API.unitTenantVehicleSlot(id));

export const removeUnitGuestVehicleSlot = (id) => (dispatch) =>
  vpp.delete(VPP_API.unitGuestVehicleSlot(id));

export const deleteUnitGuestPermit = (unitId, permitId) => (dispatch) =>
  vpp.delete(VPP_API.unitGuestVehiclePermitDelete(unitId, permitId));

export const deleteUnitTenantPermit = (unitId, permitId) => (dispatch) =>
  vpp.delete(VPP_API.unitTenantVehiclePermitDelete(unitId, permitId));

export const setUnitArchive = (id, reason) => (dispatch) =>
  vpp.patch(VPP_API.unitArchive(id), {
    archived: true,
    reason,
  });

export const createUnit = (data) => (dispatch) => vpp.post(VPP_API.unit, data);

export const resendInvitationUnit = (data, id) => (dispatch) =>
  vpp.post(VPP_API.resendUnitinvitation(id), data);

export const patchUnitStatus = (status, id) => (dispatch) =>
  vpp
    .patch(VPP_API.unitStatus(id), { status })
    .then(({ data }) => {
      dispatch(setUnitStatus({ data, id }));
      return data;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
